export default (data, store) => {
	//Set the main background image

	store.commit(
		'setMainBackgroundImage',
		`${data.ossBackgroundImage.fields.file.url}?fm=jpg&fl=progressive&w=1440&q=90`
	);

	// Set the locale
	if (data.language) store.commit('setLocale', data.language);

	// Set translation data for OSS
	if (data.customTranslations) store.commit('setCustomTranslations', data.customTranslations);

	//Set the static translation data from contentfull
	store.commit('setStaticTranslationData', data.staticTranslations);
	//Set the translation data from contentfull
	store.commit('setTranslationData', data.translationsJson);
	//Set brand logo
	store.commit('setBrandLogo', data.ossLogo.fields.file.url);
	//Set error codes
	store.commit('setErrorCodes', data.errorCodes);

	//Store all config data, and add redirect domain
	data['shopDomain'] = {
		aod: 'artofdance.nl',
		b2s: 'b2s.nl',
		dev: 'q-dance.com',
		dgtl: 'dgtl.nl',
		dominator: 'dominatorfestival.com',
		elrow: 'elrowfamily.com',
		festivalmacumba: 'fiestamacumba.nl',
		gardensofbabylon: 'thegardensofbabylon.com',
		idt: 'id-t.com',
		mananamanana: 'mananamanana.eu',
		mastersofhardcore: 'mastersofhardcore.com',
		milkshake: 'milkshakefestival.com',
		mysteryland: 'mysteryland.nl',
		openair: 'amsterdamopenair.nl',
		pleinvrees: 'pleinvrees.net',
		qdance: 'q-dance.com',
		sensation: 'sensation.com',
		strafwerk: 'strafwerk.org',
		thunderdome: 'thunderdome.com',
		vunzigedeuntjes: 'vunzigedeuntjes.nl',
		wttf: 'welcometothefuture.nl',
		zwartecross: 'zwartecross.nl'
	}[process.env.SHOPBRAND];

	store.commit('setOssConfig', data);
	// console.log('▒ Saving Shop DATA to store', store.getters['shopconfig/getData']);
};
